module.exports = __webpack_public_path__ + "static/img/banner.3cb12522.jpg";